import React, {useState} from "react";
import "./CollaborationBanner.scss";
import ButtonLink from "../Buttons/ButtonLink/ButtonLink";
import QuoteProjectModal from "../Modals";

const CollaborationBanner = ({themeOptions}) => {

    if (!themeOptions) {
        return null;
    }

    const {
        collaboration_banner_title,
        collaboration_banner_subtitle,
        collaboration_banner_button_title,
        header_button_url
    } = themeOptions;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleButtonClick = (e) => {
        e.preventDefault(); // Zapobiega domyślnemu przeładowaniu strony
        setIsModalOpen(true); // Otwiera modal
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Zamknięcie modala
    };

    return (
        <div className="collaboration-banner">
            <div className="collaboration-banner--inside">
                    <div className="collaboration-banner--inside__left">
                        <h4>{collaboration_banner_title}</h4>
                        <h5>{collaboration_banner_subtitle}</h5>
                    </div>
                    <div className="collaboration-banner--inside__right">
                           <ButtonLink
                               classes={[
                                   "btn",
                                   "btn-link",
                                   "btn-contact-form",
                                   "btn-form",
                                   "btn-collaboration",
                                   "left-to-right-animate",
                                   "blue-to-black",
                               ]}
                               text={collaboration_banner_button_title || "Zapytaj nas"}
                               href={header_button_url}
                               hasIcon={true}
                               iconClasses={["calendar-icon"]}
                               onClick={handleButtonClick}
                           />
                    </div>
            </div>
            <QuoteProjectModal isOpen={isModalOpen} onClose={handleCloseModal}/>
        </div>
    );
};

export default CollaborationBanner;
